const colors_hz = [
  '#44bbff',
  '#c09eda',
  '#9bd51f',
  '#f7b42c',
  '#f27490',
  '#fc575e',
  '#f27624',
  '#90d5ec',
  '#f49ac1',
  '#ca5',
  '#b5e4f2',
  '#9ab'
];
const colors_d3 = [
  '#1f77b4',
  '#aec7e8',
  '#ff7f0e',
  '#ffbb78',
  '#2ca02c',
  '#98df8a',
  '#d62728',
  '#ff9896',
  '#9467bd',
  '#c5b0d5',
  '#8c564b',
  '#c49c94',
  '#e377c2',
  '#f7b6d2',
  '#7f7f7f',
  '#c7c7c7',
  '#bcbd22',
  '#dbdb8d',
  '#17becf',
  '#9edae5'
];

// cosnt colors_2 = ['#4682b4', '#2ca02c', '#d65757', '#db843d', '#a47d7c', '#bcbd22', '#ff9896', '#f7b42c', '#80699b', '#c5b0d5'];

export const colors = [...colors_hz, ...colors_d3];
